module.exports = __webpack_public_path__ + "img/selected3-min.eb1abfcc.png";